import { Component, OnInit, ViewChild } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { ModalService } from '../modal.service';

@Component({
  selector: 'app-modal-completed',
  templateUrl: './modal-completed.component.html',
  styleUrls: ['./modal-completed.component.scss']
})
export class ModalCompletedComponent implements OnInit {

  @ViewChild('completedModal', {static: false}) modal;
  modalRef: BsModalRef;
  configmodal = {
    class: 'modal-dialog-centered modal-md', 
    ignoreBackdropClick: true, 
    keyboard: false,
    animated: false
  };
  
  callback: Function;
  title: any = '';
  content: any = '';
  isShowBtn = true;
  isShow = false;

  constructor(
    private modalServ: ModalService,
    private modalService: BsModalService,
  ) { }

  ngOnInit() {
    this.modalServ.onCompleted.subscribe(req => {
      this.title = '';
      this.content = req.content;
      this.title = req.title;
      this.callback = req.callback;
      if('isShowBtn' in req){
        this.isShowBtn = req.isShowBtn;
      }
      if(!this.isShow) {this.show();}
    });

    this.modalServ.onConfirmHide.subscribe(req => {
      this.hide();
    });
  }

  show() {
    if(this.modalRef){
      this.modalRef.hide();
    }
    this.isShow = true;
    this.modalRef = this.modalService.show(this.modal, this.configmodal);
  }

  hide() {
    if(this.modalRef){
      this.modalRef.hide();
      this.isShow = false;
    }
    this.callback({status: 'confirm'});
  }

  confirm(): void {
    this.isShow = false;
    this.callback({status: 'confirm'});
    if(this.modalRef){
      this.modalRef.hide();
    }
  }

}
